var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrawer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 1920,
    viewBox: "0 0 112 1920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 1920H2.37443L2.44836 1880.62L0.304001 1809.84L2.86738 1739.06L3.02348 1668.29L3.32747 1597.52L0 1526.74L2.33334 1455.97L2.63733 1385.19L2.71127 1314.42L2.44836 1243.65L2.67841 1172.88L0.616196 1102.11L2.79343 1031.34L1.3392 960.57L2.56339 889.8L1.03522 819.02L2.59624 748.25L0.230057 677.48L1.61034 606.71L1.26527 535.94L2.94131 465.17L2.90845 394.4L0.649071 323.63L2.06221 252.86L3.36855 182.09L2.75235 111.32L1.22418 40.55L1.52817 0L112 0L112 1920Z",
    fill: "#E2EB76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawer);
export default __webpack_public_path__ + "static/media/drawer.5b7ff6cc25a6a7e775c2005d8940e7ba.svg";
export { ForwardRef as ReactComponent };